import { useRecoilState } from "recoil";
import {  mostrarDividaConsolidadaLiquida } from "../atom";

const useMostrarDividaConsolidadaLiquidaState = () => {
    return useRecoilState(mostrarDividaConsolidadaLiquida);
};

export default useMostrarDividaConsolidadaLiquidaState;